export enum TriStateButtonState {
    FULLY_SELECTED = 'FULLY_SELECTED',
    PARTIAL_SELECTION = 'PARTIAL_SELECTION',
    NOT_SELECTED = 'NOT_SELECTED',
}
